import * as React from 'react';
import { styled } from '@mui/material/styles';
import Avatar from '@mui/material/Avatar';
import MuiDrawer, { drawerClasses } from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
// import SelectContent from './SelectContent';
import MenuContent from './MenuContent';
import { Autocomplete, IconButton, TextField, Tooltip } from '@mui/material';
import axios from '../api/axiosInstance';
import { useOrganizationSelect } from '../context/OrganizationSelectContext';
import { useAuth } from '../context/AuthContext';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import OptionsMenu from './OptionsMenu';


// import CardAlert from './CardAlert';
// import OptionsMenu from './OptionsMenu';

const drawerWidth = 270;
const collapsedDrawerWidth = 64;

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'collapsed' })(({ collapsed }) => ({
  width: collapsed ? collapsedDrawerWidth : drawerWidth,
  flexShrink: 0,
  boxSizing: 'border-box',
  transition: 'width 180ms ease',
  mt: 10,
  [`& .${drawerClasses.paper}`]: {
    width: collapsed ? collapsedDrawerWidth : drawerWidth,
    boxSizing: 'border-box',
    overflowX: 'hidden',
    transition: 'width 180ms ease',
  },
}));

export { drawerWidth, collapsedDrawerWidth };

export default function SideMenu({ collapsed = false, onToggleCollapsed }) {
   const [organizations, setOrganizations] = React.useState([]);
   const [branding, setBranding] = React.useState({ appName: 'OBX App', subtitle: 'Web app', logoUrl: '' });
   const { user } = useAuth()
   const { selectedOrganization, setSelectedOrganization } = useOrganizationSelect();
   
   const getProfile = async () => {
     try {
       await axios.get('/api/auth/profile');
     } catch (error) {
       console.error('Error fetching profile:', error);
     }
   };




     const fetchOrganizations = async () => {
         try {
             const response = await axios.get('/api/organizations/list');
             setOrganizations(response.data.filter((org) => !org.deleted));
         } catch (error) {
             console.error('Error fetching organizations:', error);
         }
     };

    const fetchGeneralSettings = async () => {
      try {
        const { data } = await axios.get('/api/settings/general');
        setBranding((current) => ({ ...current, ...(data?.config?.branding || {}) }));
      } catch (error) {
        console.error('Error fetching general settings:', error);
      }
    };

    React.useEffect(() => {
      fetchOrganizations();
      getProfile();
      fetchGeneralSettings();
    }, []);

    const logoSrc = branding.logoUrl
      ? `${process.env.REACT_APP_API_URL || ''}${branding.logoUrl}`
      : '/img/omnibox.png';


  return (
    <Drawer
      collapsed={collapsed}
      variant="permanent"
      sx={{
        display: { xs: 'none', md: 'block' },
        [`& .${drawerClasses.paper}`]: {
          backgroundColor: 'background.paper',
        },
      }}
    >
      <Stack
        spacing={collapsed ? 0.75 : 1}
        alignItems="center"
        sx={{
          mt: 'calc(var(--template-frame-height, 0px) + 4px)',
          p: collapsed ? 0.75 : 1.5,
          width: '100%',
        }}
      >
        <Box
          component="img"
          sx={{
            maxWidth: collapsed ? 42 : '65%',
            maxHeight: collapsed ? 30 : 68,
            objectFit: 'contain',
          }}
          alt={branding.appName || 'Logo'}
          src={logoSrc}
        />
        {!collapsed && (branding.appName || branding.subtitle) && (
          <Box sx={{ textAlign: 'center' }}>
            {branding.appName && (
              <Typography variant="subtitle2" sx={{ fontWeight: 800, lineHeight: 1.2 }}>
                {branding.appName}
              </Typography>
            )}
            {branding.subtitle && (
              <Typography variant="caption" color="text.secondary" sx={{ lineHeight: 1.2 }}>
                {branding.subtitle}
              </Typography>
            )}
          </Box>
        )}
        <Tooltip title={collapsed ? 'Déplier le menu' : 'Réduire le menu'} placement="right" arrow>
          <IconButton
            size="small"
            onClick={onToggleCollapsed}
            sx={{
              width: collapsed ? 34 : 30,
              height: collapsed ? 34 : 30,
              border: '1px solid',
              borderColor: 'divider',
              bgcolor: 'background.paper',
            }}
          >
            {collapsed ? <ChevronRightIcon fontSize="small" /> : <ChevronLeftIcon fontSize="small" />}
          </IconButton>
        </Tooltip>
      </Stack>
            {!collapsed && <Divider />}
            {!collapsed && (
              <Box
                sx={{
                  display: 'flex',
                  mt: 'calc(var(--template-frame-height, 0px) + 4px)',
                  p: 1.5,
                }}
              >
                <Autocomplete
                  disablePortal
                  size="small"
                  fullWidth
                  options={organizations}
                  getOptionLabel={(option) => option.name}
                  value={organizations.find((c) => c.name === selectedOrganization) || null}
                  onChange={(_, newValue) => {
                    setSelectedOrganization(newValue ? newValue.name : null);
                  }}
                  renderInput={(params) => <TextField {...params} label="Client" />}
                  isOptionEqualToValue={(option, value) => option.name === value.name}
                />
              </Box>
            )}
        {!collapsed && <Divider />}
        <Box
        sx={{
          overflow: 'auto',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
        }}
        >
        
        <MenuContent collapsed={collapsed} />
      </Box>
      <Stack
        direction="row"
        sx={{
          p: collapsed ? 1.25 : 2,
          gap: 1,
          justifyContent: collapsed ? 'center' : 'flex-start',
          alignItems: 'center',
          borderTop: '1px solid',
          borderColor: 'divider',
        }}
      >
        <Avatar
          sizes="small"
          alt={`${user.firstname} ${user.lastname}`}
          src="/static/images/avatar/7.jpg"
          sx={{ width: 36, height: 36 }}
        >
          {user.firstname && user.lastname
        ? `${user.firstname[0]}${user.lastname[0]}`.toUpperCase()
        : ''}
        </Avatar>
        {!collapsed && <Box sx={{ mr: 'auto' }}>
          <Typography variant="body2" sx={{ fontWeight: 500, lineHeight: '16px' }}>
        {user.firstname} {user.lastname}
          </Typography>
          <Typography variant="caption" sx={{ color: 'text.secondary' }}>
        {user.email}
          </Typography>
        </Box>}
        {!collapsed && <OptionsMenu />}
      </Stack>


    </Drawer>
  );
}